import React from "react";

import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";

import { RootState } from "../../app/store";

export type ActionType = "add" | "update" | "delete" | "cancel";
interface SnackbarState {
  open: boolean | number;
  label: string;
  customMessage?: string;
  pendingCustomMessage?: string;
  actionType: ActionType;
  additionalAction?: React.ReactNode;
}

// Define the initial state using that type
const initialState: SnackbarState = {
  open: false,
  label: "",
  customMessage: undefined,
  pendingCustomMessage: undefined,
  actionType: "add",
  additionalAction: undefined
};

export const snackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean | number>) => {
      state.open = action.payload;
    },
    setLabel: (state, action: PayloadAction<string>) => {
      state.label = action.payload;
    },
    setCustomMessage: (state, action: PayloadAction<any>) => {
      state.customMessage = action.payload;
    },
    setPendingCustomMessage: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.pendingCustomMessage = action.payload;
    },
    setActionType: (state, action: PayloadAction<ActionType>) => {
      state.actionType = action.payload;
    },
    setAdditionalAction: (
      state,
      action: PayloadAction<React.ReactNode | undefined>
    ) => {
      state.additionalAction = action.payload;
    },
    resetSnackbar: () => initialState
  }
});

// Action creators are generated for each case reducer function
export const {
  setOpen,
  setLabel,
  setCustomMessage,
  setPendingCustomMessage,
  setActionType,
  setAdditionalAction,
  resetSnackbar
} = snackbarSlice.actions;

const snackBarSelector = (state: RootState) => state.snackbar;
export const selectSnackbarOpen = createSelector(
  snackBarSelector,
  (snackbar) => snackbar.open
);
export const selectSnackbarLabel = createSelector(
  snackBarSelector,
  (snackbar) => snackbar.label
);
export const selectSnackbarCustomMessage = createSelector(
  snackBarSelector,
  (snackbar) => snackbar.customMessage
);
export const selectSnackbarPendingCustomMessage = createSelector(
  snackBarSelector,
  (snackbar) => snackbar.pendingCustomMessage
);
export const selectSnackbarActionType = createSelector(
  snackBarSelector,
  (snackbar) => snackbar.actionType
);
export const selectSnackbarAdditionalAction = createSelector(
  snackBarSelector,
  (snackbar) => snackbar.additionalAction
);

export default snackbarSlice.reducer;
